import { CellContext } from '@tanstack/react-table';
import get from 'lodash/get';
import { HealthStatus } from '../../../../health';
import { HealthIconCellRenderer } from '../../../../health/HealthIconCellRenderer';

export const HealthCellRenderer = <TData, TValue>(props: CellContext<TData, TValue>): JSX.Element => {
  const { row, column } = props;
  const value = get(row.original, column.id);
  const healthStatus = value != null ? (value as HealthStatus) : null;
  if (healthStatus == null) {
    return <div>{'—'}</div>;
  }

  return <HealthIconCellRenderer value={healthStatus} {...column.columnDef.meta?.cellTypeOptions} />;
};
